import { render, staticRenderFns } from "./customerInfoLayout.vue?vue&type=template&id=3c5dec56&scoped=true"
import script from "./customerInfoLayout.vue?vue&type=script&lang=js"
export * from "./customerInfoLayout.vue?vue&type=script&lang=js"
import style0 from "./customerInfoLayout.vue?vue&type=style&index=0&id=3c5dec56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5dec56",
  null
  
)

export default component.exports